var m = require('mithril');
var _ = require('lodash');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var equipmentModel = require('../../equipment/models/equipment');
var ontologyFields = require('../../../../../models/equipment/ontologyFields');
var propertyFieldValue = require('./propertyFieldValue');


var propertiesViewerModal = Object.assign(Object.create(Model), {});

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


propertiesViewerModal.editDialogue = function (record) {
  propertiesViewerModal.equipmentRecord = record;

  let inheretedClassData = equipmentModel.getInheretedClassData(record['@class']);
  let classDataFromOntology = inheretedClassData.foundEquipmentClass;
  let parentFieldsArray = ontologyFields.normalizeFieldDefinitions(inheretedClassData.parentFieldsArray);
  if (classDataFromOntology) {
    const hasDataAndFields = classDataFromOntology.data && classDataFromOntology.data.fields && Array.isArray(classDataFromOntology.data.fields);
    const hasValidParentFields = parentFieldsArray && Array.isArray(parentFieldsArray);
    if (hasDataAndFields) {
      if (hasValidParentFields) {
        propertiesViewerModal.equipmentFields = ontologyFields.normalizeFieldDefinitions(
          [].concat(classDataFromOntology.data.fields || [], parentFieldsArray || [])
        );
      }
    } else {
      // Use short-circuiting to assign an empty array if parentFieldsArray is not defined
      propertiesViewerModal.equipmentFields = [];
    }
  }

  key.setScope('modal');
  modal.vm.title(`${record.name || record['@class']} Properties`);
  modal.vm.body = propertiesViewerModal.view,
  modal.vm.open();
}


propertiesViewerModal.view = function () {
  return m('form', {role:'form'}, [
    (propertiesViewerModal.equipmentFields && Array.isArray(propertiesViewerModal.equipmentFields) ? propertiesViewerModal.equipmentFields : [])
    .filter(field => ontologyFields.isDisplayableFieldValue(
      ontologyFields.readEquipmentFieldValue(propertiesViewerModal.equipmentRecord, field).value,
      field
    ))
    .map(field => {
      var fieldName = ontologyFields.getFieldName(field);
      return m('div.flex', [
        m('div.mr2.nowrap.overflow-show', `${_.startCase(fieldName)}:`),
        m('div.nowrap.truncate.overflow-hidden', propertyFieldValue.render(propertiesViewerModal.equipmentRecord, field))
      ])
    })
  ])
}


module.exports = propertiesViewerModal;
